<template>
  <div 
    id="walkthrough" 
    v-if="showApp" 
    class="">
    <div class="ctn-exit-btn">
      <button class="exit-btn newfont" @click="Exit">
        <span class="material-icons">clear</span>Exit
      </button>
    </div>

      <!--div :style="progressMargin" v-if="hasPassed">
        <div
          v-for="num in this.numFrames"
          :key="num+translateH"
          @click="selectFrame(num)"
          :class="{activeFrame: num === currentFrame}"
          :style="circleshotfix"
          class="circle outline uk-background-primary"
        ></div>
      </div>-->

    <Progress 
      id="js-progressbar"
      class="progressbar"
      :percentage="progress"
      :max="Frames.length">
    </Progress>

    <app-frame 
      v-for="(item, index) in Frames"
      :key="rootwindow.width+index+2"
      :style="trn"
      :currentFrame="currentStep"
      v-bind="item"
      v-bind:form="contactForm"
      @nextstep="nextevent"
      @backstep="backevent"
      @submit="submitForm"
      @exit="Exit"
      ></app-frame>

  </div>
</template>

<script>

import Frame from '@/components/Frame.vue'
import ProgressBar from '@/components/ProgressBar.vue';
import { defaultConfig } from '../utilities/Requester.js'

export default {
  name: 'Walkthrough',
    components: {
      appFrame:Frame,
      Progress:ProgressBar
  },
  data() {
    return {
      showApp: true,
      currentFrame: 1,
      currentStep: 1,
      translateH: 0,
      progress:{
        width:"7%"
      },
      rootwindow: {
        width: 0,
        height: 0
      },
      contactForm:{
        firstName:"",
        lastName:"",
        phone:"",
        email:"",
        company:"",
        companySize:"",
        serviceInterest:[],
        message:""
      },
      Frames:[{
          id: 1,
          event_order: 1,
          event_type: 'html_text',
          html_text: "<h1>Welcome to Composer Software</h1>",
          goto:2,
          backto:1,
          showBack:false
        },
        {
          id: 2,
          event_order: 2,
          event_type: 'text_display',
          texts:[
            "We are a new up and coming software solutions company that solves real world problems with digital solutions in the cloud.",
            "We want to provide our clients with the best customer service experience and help them obtain the best software solutions for their business.",
            "We believe each business is unique and want to help based on a more personal approach.",
            "We would love the opportunity to communicate with you regarding your business's software needs.",
            "We hope to help answer your questions about composing software for your business."],
          goto:3,
          backto:1
        },
        {
          id: 3,
          event_order: 3,
          event_type: 'text_display',
          texts:[
            "We are your one stop shop for Full-Stack Development and Devops Hosting services for our clients."
          ],
          goto:4,
          backto:2
        },
        {
          id: 4,
          event_order: 4,
          event_type: 'text_display',
          texts:[
            "We are not using cookies to store your data"
          ],
          goto:5,
          backto:3
        },
        {
          id: 5,
          event_order: 5,
          event_type: 'select_input',
          texts:[
            "What kind of services or information you think you're looking for?",
            "Select as many options you think apply"
          ],
          selection:[
            "User Interface",
            "API Services",
            "3rd Party API Integration",
            "General Purpose Application",
            "Website",
            "Automation",
            "Rapid Prototype",
            "E-commerce",
            "SaaS Product",
            "Database Services",
            "Content Management System",
            "Blog",
            "Data Visualization",
            "General Information",
            "Data Mangement",
            "Wordpress",
            "Shopify",
            "Wix",
            "Squarespace",
            "Other"
          ],
          minSelection:1,
          maxSelection:18,
          fontsize:"2em",
          For:"serviceInterest",
          verify:[],
          goto:6,
          backto:4
        },
        {
          id:6,
          event_order: 6,
          event_type: 'text_input',
          texts:["What is your first name? So we know who we are contacting."],
          fontsize:"2em",
          placeholder:"James",
          For:"firstName",
          verify:[{"minLength":2}],
          goto:7,
          backto:5
        },
        {
          id:7,
          event_order: 7,
          event_type: 'text_input',
          texts:["What is your last name?"," So we can uniquely identify you with other people who have your same first name?"],
          fontsize:"2em",
          placeholder:"Smith",
          For:"lastName",
          verify:[
            {"minLength":2},
          ],
          goto:8,
          backto:6
        },
        {
          id: 8,
          event_order: 8,
          event_type: 'text_input',
          texts:[
            "Thank you for providing your name, can we please have your email to send contact or confirmation?"
          ],
          fontsize:"2em",
          placeholder:"email@provider.ext",
          maxLength:"55",
          For:"email",
          verify:[{"minLength":3},{"pattern":"email"},{"whitespace":""}],
          goto:9,
          backto:7
        },
        {
          id: 9,
          event_order: 9,
          event_type: 'text_input',
          texts:[
            "Thank you for providing your email",
            "We prefer communication over phone and will have one of our professional software composers contact you",
            "They will attempt to contact you, communicate any details you will need, and follow up via email"
          ],
          fontsize:"2em",
          For:"phone",
          placeholder:"111-555-0909",
          verify:[
            {"minLength":9},
            {"whitespace":""},
            {"chars":[" ","1","2","3","4","5","6","7","8","9","0","-","(",")"]},
            {"limitchars":["(",")"],limit:1},
            {"limitchars":["-"],limit:3},
            {"maxLength":20}
          ],
          goto:10,
          backto:8
        },
        {
          id: 10,
          event_order: 10,
          event_type: 'text_input',
          texts:[
            "Thank you for providing your phone",
            "Can you provide your company name?",
            "If this does not apply, you can leave it blank"
          ],
          fontsize:"2em",
          For:"company",
          placeholder:"Coca Cola",
          verify:[],
          goto:11,
          backto:9
        },
        {
          id: 11,
          event_order: 11,
          event_type: 'select_input',
          texts:[
            "Thank you",
            "Can you provide the approximate size of your company?",
            "If this does not apply, select the 1 option"
          ],
          selection:[
            "1",
            "2-15",
            "16-50",
            "51-100",
            "101-500",
            "501-1000",
            "1001-10000",
            "10000+"
          ],
          minSelection:1,
          maxSelection:1,
          fontsize:"2em",
          For:"companySize",
          verify:[],
          goto:12,
          backto:10
        },
        
        {
          id: 12,
          event_order: 12,
          event_type: 'textarea_input',
          texts:["Anything else you would like to mention to us?"],
          fontsize:"3em",
          For:"message",
          placeholder:"",
          maxLength:"255",
          goto:13,
          backto:11,
          showNext:false
        },
        {
          id: 13,
          event_order: 13,
          event_type: 'review_page',
          texts:["Review Details"],
          showExit:true,
          showNext:false,
          fontsize:"3em",
          titleMap:{
            firstName:"First Name",
            lastName:"Last Name",
            phone:"Phone",
            email:"Email",
            company:"Company",
            companySize:"Company Size",
            serviceInterest:"Service Interests",
            message:"Message"
          },
          goto:14,
          backto:12
        },
        {
          id: 14,
          event_order: 14,
          event_type: 'captcha_page',
          texts:["Please Complete the Captcha Below"],
          fontsize:"3em",
          goto:15,
          backto:13,
          showNext:false
        },
        {
          id:15,
          event_order:15,
          event_type: 'timeout_display',
          texts:[
            "Thank you!",
            "Message Sent Successfully!",
            "Look out for a confirmation Email"
          ],
          timeout:7000,
          goto:1,
          exit:true,
          showNext:false,
          showBack:false
        },
        {
          id:16,
          event_order:16,
          event_type: 'timeout_display',
          texts:[
            "Sorry! Something went wrong with your contact request."
          ],
          goto:17,
          backto:1,
          showNext:false
        },
        {
          id:17,
          event_order:17,
          event_type: 'timeout_display',
          texts:[
            "Error"
          ],
          timeout:10000,
          goto:1,
          exit:true,
          backto:1,
          showNext:false
        },
      ],
      arbitrary: [],
      errors: []
    }
  },
  computed: {
    trn(){
      if(window.innerWidth < 800){
        return `transform: translateX(${ this.translateH }px; width:${ this.rootwindow.width }px; top: 17vh;`
      } else {
        return `transform: translateX(${ this.translateH }px; width:${ this.rootwindow.width }px`
      }
    },
    progressMargin(){
      if(window.innerWidth < 420){
        return `margin-top:2.5vh;`
      } else if(window.innerWidth < 801){
        return `margin-top:-2vh;`
      } else {
        return `margin-top:-6vh;`
      }
    },
    screensizecomp(){
      if(window.innerWidth < 801){
        return `margin-top: 6vh;`
      } else {
        return `margin-top:3vh;`
      }
    }
  },
  watch:{
    currentStep:function(){
      //console.log(this.currentStep);
      let percentage = Math.round((this.currentStep/13)*100)
      //console.log(percentage);
      this.progress = {width:`${percentage}%`};
      //console.log(this.percentage)
    },
    showApp:function(){
    } 
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  updated(){

  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    Exit(){
      this.$emit('exit');
      //this.currentStep = 1;
    },
    ScrollTop(){
      var a = document.getElementById("walkthrough");
      a.scrollTop = 0;
    },
		nextevent(value){
      if(value.stepVal === 0){
        this.Exit();
      } else {
        this.currentStep = value.stepVal;
        this.ScrollTop();
      }
      if(value.val !== undefined && value.val && this.contactForm[value.for] !== undefined) this.contactForm[value.for] = value.val;
      //console.log(this.contactForm);
		},
		backevent(value){
			this.slideDirection = "backwards";
      //this.dataWeWant[String(value.for)] = "";
			this.currentStep = value.stepVal
			this.slideDirection = "fadeslide" 
		},
    handleError(d){
      this.Frames[17].texts.push(d.message)
      this.nextevent({stepVal:16})
      return d;
    },
    handleResize() {
      this.rootwindow.width = window.innerWidth ;
      this.rootwindow.height = window.innerHeight;
      this.translateH = ((this.currentFrame-1)*-1)*window.innerWidth;
    },
    initializeForm(d){
      this.contactForm = {
        firstName:"",
        lastName:"",
        phone:"",
        email:"",
        company:"",
        companySize:"",
        serviceInterest:[],
        message:""
      }
      document.appObserver.emit('resetTextInput');
      document.appObserver.emit('resetTextAreaInput');
      document.appObserver.emit('resetSelectInput');
      return d;
    },
    submitForm(){
      let message = document.messageRequest('/message')
      let options = defaultConfig()
      this.contactForm['captcha'] = window.grecaptcha.getResponse(window.captcha2)
      //console.log(this.contactForm)
      //this.contactForm['captcha'] = document.querySelector("#g-recaptcha-response").value;
      options.method = "POST";
      options.headers['Content-Type'] = "application/json";
      options.data = JSON.stringify(this.contactForm);
      let handleResponse = e => {
        this.$emit('success', e.data)
        this.nextevent({stepVal:15})
      }
      message(options)
        .then(handleResponse)
        .then(this.initializeForm)
        .catch(this.handleError)
    },
    previousFrame(event){
      this.arbitrary.push(event);
    }
  }
}
</script>

<style>

.navigate-frame-btn {
  min-height: 7vh;
  font-size: 1.6em !important;
}

#walkthrough {
  scroll-behavior:smooth;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 9vw 5vw 3vw 5vw;
  /* padding-top: ; */
  /*transition: all 333ms ease-in; */
  animation: fadein 333ms ease;
  position: fixed;
  width: 100vw;
  height: 94%;
  background-color: #ffffff;
  overflow-x: hidden;
  z-index:11;
}

.frame-max {
  position: absolute;
  /*background-color: #ffffff;*/
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin-top: 2vh;
  padding: 0 5vw;
  text-align: left;
  transition: all 800ms ease-in-out;
}

.outline {
  border: 1px solid #575757;
  margin-bottom: 0px;
}

.circle {
  display: inline-block;
  margin: 10px;
  padding: 5px;
  border-radius: 50%;
  width: .4vw;
  height: .4vw;
  background-color: #9a9a9a;
  opacity: 0.4;
}

.activeFrame {
  opacity: 1;
  background-color: #1e87f0;
}

.btn-extra-large-text {
  font-size: 1.7em;
}
.ctn-exit-btn {
  position: absolute;
  top: 2%;
  left: 2%;
}

.newfont {
  font-family:'Varela Round';
}
.exit-btn {
  background-color:#ffb31b;
  color:#fff;
  font-weight:600;
  font-size:1.2em;
  padding: 10px 20px;
  border-radius:9px;
  display:flex;
  align-items:center;
  cursor:pointer;
          
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media only screen and (max-width: 600px) {
  .progressbar {
    margin-top:50px;
  }
}

</style>
